import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { LayoutTypesEnum } from '../../../../Common/Layout/enums/layout-types.enum';
import { LeftSidebarService } from '../../../../Common/Layout/services/left-sidebar.service';
import { Mode } from '../../../../Common/Layout/enums/mode.enum';
import { AmplifyLeftSidebarService } from '../../services/amplify-left-sidebar.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LeftSidebarManagementService } from '../../../../Common/Layout/services/left-sidebar-management.service';
import { AmplifyLeftSidebarManagementService } from '../../services/amplify-left-sidebar-management.service';

@Component({
    selector: 'agpr-amplify',
    templateUrl: './amplify.component.html',
    styleUrls: ['./amplify.component.scss'],
    providers: [
        {
            provide: LeftSidebarService,
            useExisting: AmplifyLeftSidebarService
        },
        {
            provide: LeftSidebarManagementService,
            useClass: AmplifyLeftSidebarManagementService
        }
    ],
    standalone: false
})
export class AmplifyComponent implements OnDestroy {
    layout = LayoutTypesEnum.horizontal;

    public subscriptions: Subscription[] = [];

    isPAAccount: boolean = false;

    hideManageListDialog: boolean = false;

    constructor(
        private configService: ConfigService,
        private sidebarService: AmplifyLeftSidebarService
    ) {
        this.isPAAccount = this.configService.brandGUIDIsPaMedia();
        this.subscriptions.push(
            this.sidebarService.getMode().subscribe(
                (mode) => {
                    this.hideManageListDialog = mode === Mode.editorial;
                }
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((value) => {
            value.unsubscribe();
        });
    }
}
